export { default as LtiToolRegistration } from './component/LtiToolRegistration';
export const LtiToolRegistrationDynamic = () => import('./component/LtiToolRegistration');
